// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3b145fd5","498":"1f991dae","703":"cc00df8e","787":"0633c53b"}[chunkId] + ".chunk.js";
};